import { useRef as u, useState as m, useCallback as d } from "react";
import { u as R } from "./use-isomorphic-layout-effect.BGfaCOP1.js";
function g(o = !0) {
  const n = u(null), [i, l] = m({
    width: 0,
    height: 0,
    domRect: void 0
  }), c = u(null), e = u(null), s = d((r) => {
    const t = r[0];
    t && (e.current && cancelAnimationFrame(e.current), e.current = requestAnimationFrame(() => {
      const {
        width: a,
        height: f
      } = t.contentRect;
      l({
        width: a,
        height: f,
        // getBoundingClientRect is safe here — we're in a new frame,
        // outside the ResizeObserver callback
        domRect: t.target.getBoundingClientRect()
      }), e.current = null;
    }));
  }, []);
  return R(() => {
    if (!n.current)
      return;
    c.current || (c.current = new ResizeObserver(s));
    const r = c.current, t = n.current;
    return o ? r.observe(t) : r.disconnect(), () => {
      r.disconnect(), e.current && (cancelAnimationFrame(e.current), e.current = null);
    };
  }, [o, s]), [n, i];
}
export {
  g as u
};
//# sourceMappingURL=use-resize-observer.CEagjEFr.js.map
